import script from "./withdrawPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./withdrawPopup.vue?vue&type=script&setup=true&lang=ts"

import "./withdrawPopup.vue?vue&type=style&index=0&id=e9ed879c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9ed879c"]])

export default __exports__